import React from 'react';
import PropTypes from 'prop-types';
import DataTable from '../shared/DataTable';

const COLUMNS = [
  { key: 'name', label: 'イベント名' },
  { key: 'event_date', label: '開催日' },
  { key: 'pv', label: 'PV' },
  { key: 'participants', label: '参加者' },
  { key: 'revenue', label: '売上', format: (v) => `¥${Number(v).toLocaleString()}` },
  { key: 'cvr', label: 'CVR', format: (v) => `${v}%` },
];

const EventComparisonTable = ({ events }) => (
  <div className="o-dashboard__section">
    <h3 className="o-dashboard__section-title">直近イベント一覧</h3>
    <DataTable columns={COLUMNS} rows={events} />
  </div>
);

EventComparisonTable.propTypes = {
  events: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      event_date: PropTypes.string,
      pv: PropTypes.number,
      participants: PropTypes.number,
      revenue: PropTypes.number,
      cvr: PropTypes.number,
    })
  ).isRequired,
};

export default EventComparisonTable;
